module.exports = __webpack_public_path__ + "components/flag/static/square/hk-52d17efd8233ada5d9282ca32f7378e1.svg";